import { render, staticRenderFns } from "./CallsSection.vue?vue&type=template&id=6c86c3e3&"
import script from "./CallsSection.vue?vue&type=script&lang=js&"
export * from "./CallsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports